<template>
	<div
		class="ld-upload"
		draggable="true"
		@dragover="dragOverImage"
		@drop="dropImage"
	>
		<div class="upload-container">
			<div
				class="upload-preview"
				:class="{
					hidden: !image && !fileName,
					'not-picture': fileName
				}"
				@click="
					defaultFullScreen ? eventShowPreviewFullScreen : () => {}
				"
			>
				<button
					type="button"
					@click="closePreview"
					class="upload-preview-close"
					:class="{ hidden: disabled }"
				>
					<i translate="translate" class="material-icons notranslate">
						clear
					</i>
				</button>
				<img v-show="image" :id="idPreview" :src="image" :alt="alt" />
				<h4  v-show="!image" :id="idPreview" class="text-archive text-center">
					{{ this.fileName }}
				</h4>
			</div>

			<div
				class="upload-input"
				:class="{ hidden: image || fileName }"
				@click="triggerInput"
			>
				<slot name="text"></slot>
				<input
					:accept="accept"
					type="file"
					:name="name"
					:id="id"
					multiple
					@change="changedInput"
				/>
			</div>
		</div>
		<ld-popup
			class="ld-upload-preview-fullscreen"
			:fullscreen="true"
			title=""
			:active.sync="showPreviewFullScreen"
		>
			<template v-slot:custom>
				<img
					v-if="!imageFullScreen"
					:id="idPreview"
					:src="image"
					:alt="alt"
				/>
				<img
					v-if="imageFullScreen"
					:id="idPreview"
					:src="imageFullScreen"
					:alt="alt"
				/>
			</template>
		</ld-popup>
	</div>
</template>

<script>
export default {
	name: "LdUpload",
	props: {
		text: String,
		name: {
			type: String,
			required: true
		},
		id: String,
		accept: {
			type: String,
			default: ".png, .jpg, .jpeg"
		},
		default: { type: String, default: null },
		defaultFullScreen: String,
		alt: String,
		disabled: {
			type: Boolean,
			default: false
		},
		foto: {
			required: false
		},
		fotos: {
			required: false
		}
	},
	data() {
		return {
			image: null,
			fileName: null,
			imageFullScreen: null,
			showPreviewFullScreen: false
		};
	},
	computed: {
		idPreview() {
			return `${this.name}-preview`;
		},
	},
	methods: {
		changedInput(event) {
			this.setPreview(event);

			if (event.target && event.target.files && event.target.files.length) {
				this.$emit("update:foto", event.target.files[0]);
				this.$emit("update:fotos", event.target.files);
			}
		},
		dropImage(event) {
			event.stopPropagation();
			event.preventDefault();

			const { files } = event.dataTransfer;
			const $input = this.$el.querySelector(`input[name="${this.name}"]`);

			if (
				$input &&
				!this.default &&
				!$input.files.length &&
				files.length
			) {
				const file = files[0];
				this.setPreview({}, file);

				$input.files = files;
				this.$emit("update:foto", files[0]);
				this.$emit("update:fotos", files);
			}
		},
		dragOverImage(event) {
			event.stopPropagation();
			event.preventDefault();
		},
		eventShowPreviewFullScreen(event) {
			try {
				const $uploadPreview = this.$el.querySelector(
					".upload-preview"
				);

				if ($uploadPreview && event.target == $uploadPreview) {
					this.showPreviewFullScreen = true && !this.fileName;
				}
			} catch (error) {
				return;
			}
		},
		closePreview(event) {
			const $button = event.target;

			this.imageFullScreen = null;

			if ($button) {
				const $uploadPreview = $button.parentNode;
				const $input = this.$el.querySelector(
					`input[name="${this.name}"]`
				);

				if ($input) {
					$input.value = null;
					this.$emit("update:foto", null);
					this.$emit("update:fotos", null);
				}

				if ($uploadPreview) {
					$uploadPreview.classList.add("hidden");
					this.image = null;
					this.fileName = null;
					this.$emit("update:default", null);
					// this.default = null;
				}
			}
		},
		showPreview() {
			const $previewImg = document.getElementById(this.idPreview);

			if ($previewImg) {
				const $uploadPreview = $previewImg.parentNode;
				const $uploadPreviewText = $previewImg.parentNode;

				if ($uploadPreview) {
					$uploadPreview.classList.remove("hidden");
				} else if ($uploadPreviewText) {
					$uploadPreviewText.classList.remove("hidden");
				}
			}
		},
		triggerInput(event) {
			const $uploadInput = event.target;

			if ($uploadInput) {
				const $input = $uploadInput.querySelector("input");

				if ($input) {
					$input.click();
				}
			}
		},
		setPreview(event, file) {
			try {
				if (!file) {
					file = event.target.files[0];
				}

				if (file) {
					const isImage = /image/g.test(file.type);

					if (isImage) {
						const pathFile = URL.createObjectURL(file);

						if (pathFile) {
							const $previewImg = document.getElementById(
								this.idPreview
							);

							if ($previewImg) {
								this.image = pathFile;
								this.showPreview();
							}
						}
					} else {
						this.fileName = file.name;
						this.showPreview();
					}
				}
			} catch (error) {
				return;
			}
		},
		setDefaultImage() {
			if (this.default) {
				this.image = this.default;
			}

			if (this.defaultFullScreen) {
				this.imageFullScreen = this.defaultFullScreen;
			}
		}
	},
	watch: {
		default() {
			this.setDefaultImage();
		}
	},
	beforeMount() {
		this.setDefaultImage();
	}
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/_variables.scss";

.ld-upload {
	position: relative;
	display: inline-block;
	width: 200px;
	height: 200px;
	margin-top: 5px;

	& .upload-container {
		position: relative;
		width: 100%;
		height: 100%;
	}

	& .upload-preview {
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		background: #fff;
		transition: all 0.2s ease;
		border-radius: 10px;
		overflow: hidden;
		cursor: pointer;

		&.not-picture {
			cursor: default;
		}

		&:hover {
			transform: scale(0.99, 0.99);

			& button {
				opacity: 1 !important;
				transform: translate(-4px, 4px);
			}
		}

		& button {
			display: flex;
			justify-content: center;
			align-items: center;
			position: absolute;
			top: 5px;
			right: 5px;
			width: 27px;
			height: 27px;
			border: none;
			border-radius: 5px;
			background: rgba(0, 0, 0, 0.1);
			cursor: pointer;
			opacity: 0;
			transition: all 0.2s ease;
			z-index: 1;

			&:hover {
				border-radius: 50%;
				background: $danger;
			}

			i {
				color: #fff;
				font-size: 1.4rem;
				pointer-events: none;
			}
		}

		img {
			position: absolute;
			left: 50%;
			top: 50%;
			max-width: none;
			max-height: 200px;
			transform: translate(-50%, -50%);
			pointer-events: none;
		}

		h4 {
			color: #626262;
			font-size: 16px;
			font-weight: bold;
			word-break: break-word;

			-webkit-touch-callout: none; /* iOS Safari */
			-webkit-user-select: none; /* Safari */
			-khtml-user-select: none; /* Konqueror HTML */
			-moz-user-select: none; /* Old versions of Firefox */
			-ms-user-select: none; /* Internet Explorer/Edge */
			user-select: none;
		}
	}

	& .upload-input {
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		overflow: hidden;
		width: 100%;
		height: 100%;
		padding: 10px !important;
		background: #f5f5f5;
		border-radius: 10px;
		border: 1px dashed rgba(0, 0, 0, 0.1);
		cursor: pointer;

		input {
			position: absolute;
			left: -1000px;
			width: 0px;
			height: 0px;
		}

		p,
		h4 {
			color: #626262;
			font-size: 14px;
			font-weight: bold;
			line-height: 1.5;
			pointer-events: none;

			-webkit-touch-callout: none; /* iOS Safari */
			-webkit-user-select: none; /* Safari */
			-khtml-user-select: none; /* Konqueror HTML */
			-moz-user-select: none; /* Old versions of Firefox */
			-ms-user-select: none; /* Internet Explorer/Edge */
			user-select: none;
		}
	}
}

.ld-upload-preview-fullscreen {
	padding: 36px;

	.vs-popup {
		max-width: 100%;
		width: auto !important;
		height: auto !important;
		overflow: hidden;
	}

	.vs-popup--header {
		height: 0px;

		h3 {
			padding: 0 !important;
		}

		.vs-popup--close {
			top: 28px;
			right: 10px;
			z-index: 10;
			background: $danger !important;
			color: #fff;
		}
	}

	.vs-popup--content {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		overflow: hidden;
		max-width: 100%;
		max-height: 100% !important;

		img {
			max-width: 100%;
			max-height: 100%;
		}
	}

	@media screen and (max-width: 600px) {
		padding: 0 !important;

		.vs-popup--content {
			width: 100%;
			padding: 0 !important;
			margin: 0 !important;
		}
	}
}
</style>
